import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useSettingsState } from "@/context/SettingsStateContext";
import useSettingLanguage from "@/hooks/useSettingLanguage";

export default function CustomLanguageInputModal() {
  const {
    customLanguageModalOpen,
    setCustomLanguageModalOpen,
    customLanguageInput,
    setCustomLanguageInput,
  } = useSettingsState();
  const { handleCustomLanguageSubmit } = useSettingLanguage();

  return (
    <Dialog open={customLanguageModalOpen} onOpenChange={setCustomLanguageModalOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <form onSubmit={handleCustomLanguageSubmit}>
          <DialogHeader>
            <DialogTitle>Custom Language Code</DialogTitle>
            <DialogDescription>
              Enter a valid ISO language code (e.g., 'is' for Icelandic, 'uk' for
              Ukrainian).
              <a
                href="https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline ml-1"
              >
                View ISO 639-1 codes
              </a>
            </DialogDescription>
          </DialogHeader>

          <div className="py-4">
            <Input
              id="customLanguage"
              className="w-full"
              placeholder="Enter language code (e.g., is, uk)"
              value={customLanguageInput}
              onChange={(e) => setCustomLanguageInput(e.target.value)}
              autoFocus
            />
          </div>

          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={() => setCustomLanguageModalOpen(false)}
            >
              Cancel
            </Button>
            <Button type="submit">Save Language</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
